var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseFromImage',{attrs:{"dateTitle":"this is the date to add the attraction","addToRide":_vm.addToRide}})
}
var staticRenderFns = []

export { render, staticRenderFns }